import {
  CampaignEventFields,
  CampaignEventWithoutDerivedFields,
} from 'khshared/types/campaigns/CampaignEvent';

import useLogger from './useLogger';

export default function useLogCampaignEvent(
  getCampaignLoggerFields?: () => Partial<CampaignEventWithoutDerivedFields>,
): (campaignEvent: CampaignEventWithoutDerivedFields) => void {
  const logger = useLogger();

  return function logCampaignEvent(campaignEvent: CampaignEventFields) {
    const campaignLoggerFields = getCampaignLoggerFields?.();
    if (campaignLoggerFields != null && campaignLoggerFields.patientCampaignStateID != null)
      logger.info({
        ...campaignEvent,
        ...campaignLoggerFields,
        isCampaignEvent: true,
      });
  };
}
